// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__C3sYq","videoPlayer":"VideoHero_videoPlayer__75NeQ","content":"VideoHero_content__Q3dEj"};